"use client";

import { useEffect } from "react";

import { getOneTrustConsent, subscribeToOneTrustConsent } from "@up/analytics";
import { ownerInit, profileInit, useTheme } from "@up/data";

import { brazeInit } from "./braze-init";
import { datadogInit } from "./datadog-init";
import { heapDisable, heapEnable, heapLoaderInit } from "./heap-loader";

export const FrontendInit = () => {
  const theme = useTheme();

  useEffect(() => {
    brazeInit();
    heapLoaderInit(process.env.NEXT_PUBLIC_HEAP_ID);
    if (theme.analyticsPartnerName) {
      datadogInit();
    }

    profileInit();
    ownerInit();

    // Gate Heap on OneTrust performance/analytics consent. Subscribe
    // imperatively (not via a reactive effect) so a revocation flips Heap's
    // kill-switch synchronously inside the OneTrustGroupsUpdated dispatch,
    // before Heap's timers can fire again — a React render + passive effect
    // would leave a window where tracking continues after consent is withdrawn.
    //
    // Fail closed: only an explicit grant (1) keeps Heap enabled. Every other
    // state disables it, including -1 (not yet collected), where heapDisable()
    // safely no-ops while the loader is idle.
    const syncHeapConsent = () => {
      const consent = getOneTrustConsent();
      console.log("syncHeapConsent: ", consent);
      if (consent.performanceCookies === 1) {
        heapEnable();
      } else {
        heapDisable();
      }
    };
    syncHeapConsent();

    return subscribeToOneTrustConsent(syncHeapConsent);
  }, []);

  return null;
};
